<template>
  <abstract-dropdown-container v-model="selectedValue" :options="{...defaultOptions, ...options}">
    <template v-slot:hint-top>
      <slot name="hint-top"></slot>
    </template>
    <template v-slot:hint-bottom>
      <slot name="hint-bottom"></slot>
    </template>
  </abstract-dropdown-container>
</template>

<script>
import {ENVELOPES_TYPE_LIST} from "actions/envelopes";

export default {
  name: "FieldsDropdownEnvelopeTypes",
  props: {
    value: {},
    options: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedValue: this.value,
      defaultOptions: {
        id: "envelope-type",
        prepareResponseDataHandler: this.prepareResponseData,
        customLabelHandler: this.customLabel,
        action: ENVELOPES_TYPE_LIST
      }
    };
  },
  watch: {
    value: function (newVal) {
      this.selectedValue = newVal;
    },
    selectedValue: function (newVal) {
      this.$emit('input', newVal);
    }
  },
  methods: {
    customLabel(value) {
      return this.$i18n.t(`lists.envelope_types.${value.name.toLowerCase()}`);
    },
    prepareResponseData(data) {
      let preparedData = [];
      data.forEach(function (value) {
        preparedData.push({'id': value, 'name': `${value}`});
      });
      return preparedData;
    }
  }
}
</script>

<style scoped>

</style>